<template>
  <v-card class="m-4" elevation="0">
    <v-skeleton-loader
      v-if="loading"
      v-bind="attrs"
      type="article, actions"
    ></v-skeleton-loader>
    <template v-else>
      <v-card-title>Cliente {{ customer.company_name }}</v-card-title>
      <v-card-text>
        <div>
          <iel-table :headers="customerheders">
            <tr>
              <iel-table-cell>{{ customer.person_type }}</iel-table-cell>
              <iel-table-cell>{{ customer.channel }}</iel-table-cell>
              <iel-table-cell>{{ customer.custumer_code }}</iel-table-cell>
              <iel-table-cell>{{ customer.rfc }}</iel-table-cell>
              <iel-table-cell>{{ customer.company_name }}</iel-table-cell>
            </tr>
          </iel-table>
        </div>
        <p>Datos Dirección</p>
        <div>
          <iel-table :headers="addressheders">
            <tr>
              <iel-table-cell>{{ customer.a_street }}</iel-table-cell>
              <iel-table-cell>{{ customer.a_number }}</iel-table-cell>
              <iel-table-cell>{{ customer.interior_number }}</iel-table-cell>
              <iel-table-cell>{{ customer.a_suburb }}</iel-table-cell>
              <iel-table-cell>{{ customer.a_town }}</iel-table-cell>
              <iel-table-cell>{{ customer.a_postal_code }}</iel-table-cell>
              <iel-table-cell>{{ customer.a_estate }}</iel-table-cell>
            </tr>
          </iel-table>
        </div>
        <p>Datos Fiscales</p>
        <div>
          <iel-table :headers="iusaheaders">
            <tr>
              <iel-table-cell>{{ customer.agent_number }}</iel-table-cell>
              <iel-table-cell>{{ customer.agent_name }}</iel-table-cell>
              <iel-table-cell>{{ customer.agent_email }}</iel-table-cell>
              <iel-table-cell>{{ customer.manager_code }}</iel-table-cell>
              <iel-table-cell>{{ customer.manager }}</iel-table-cell>
              <iel-table-cell>{{ customer.manager_email }}</iel-table-cell>
              <iel-table-cell>
                {{ customer.assistant_manager_code }}
              </iel-table-cell>
              <iel-table-cell>{{ customer.assistant_manager }}</iel-table-cell>
            </tr>
          </iel-table>
        </div>
        <p>Datos Asesor</p>
        <div class="fiscal-data">
          <div class="fiscal-data-sales">
            <iel-table :headers="[{ text: 'Zona' }, { text: 'Clave' }]">
              <tr>
                <th class="boder-x-none text-dark">Oficina de Ventas</th>
                <iel-table-cell>
                  {{ customer.fiscal.sales_office }}
                </iel-table-cell>
              </tr>
              <tr>
                <th class="boder-x-none text-dark">Zona de Ventas</th>
                <iel-table-cell>{{
                  customer.fiscal.sales_area
                }}</iel-table-cell>
              </tr>
              <tr>
                <th class="boder-x-none text-dark">Centro de suministro</th>
                <iel-table-cell>
                  {{ customer.fiscal.supply_center }}
                </iel-table-cell>
              </tr>
              <tr>
                <th class="boder-x-none text-dark">Código de ramo</th>
                <iel-table-cell>{{
                  customer.fiscal.branch_code
                }}</iel-table-cell>
              </tr>
              <tr>
                <th class="boder-x-none text-dark">Zona de transporte</th>
                <iel-table-cell>
                  {{ customer.fiscal.transport_area }}
                </iel-table-cell>
              </tr>
            </iel-table>
          </div>
          <div class="fiscal-data-data">
            <iel-table :headers="fiscalpayment">
              <iel-table-cell>
                {{ customer.fiscal.fiscal_regimen }}
              </iel-table-cell>
              <iel-table-cell>
                {{ customer.fiscal?.way_pay?.code }} <br />{{
                  customer.fiscal?.way_pay?.name
                }}
              </iel-table-cell>
              <iel-table-cell>
                {{ customer.fiscal.payment_method }}
              </iel-table-cell>
              <iel-table-cell>
                {{ customer.fiscal?.cfdi?.code }} <br />
                {{ customer.fiscal?.cfdi?.name }}
              </iel-table-cell>
              <iel-table-cell>
                {{ customer.fiscal.iva == 1 ? '16 %' : '' }}
              </iel-table-cell>
            </iel-table>
            <iel-table :headers="fiscalheders">
              <tr>
                <iel-table-cell>
                  {{ customer.fiscal.request_credit }}
                </iel-table-cell>
                <iel-table-cell>
                  {{ customer.fiscal.payment_condition }}
                </iel-table-cell>
                <iel-table-cell>
                  {{ customer.fiscal.delivery_fiscal_addres }}
                </iel-table-cell>
                <iel-table-cell>
                  {{ customer.fiscal.fiscal_rep_name }}
                </iel-table-cell>
                <iel-table-cell>
                  {{ customer.fiscal.line_request_credit }}
                </iel-table-cell>
                <iel-table-cell>{{
                  customer.fiscal.month_sales
                }}</iel-table-cell>
                <iel-table-cell>
                  {{ customer.fiscal.business_size }}
                </iel-table-cell>
                <iel-table-cell>
                  {{ customer.fiscal.line_bussines }}
                </iel-table-cell>
                <iel-table-cell>
                  {{ customer.fiscal.own_facilities }}
                </iel-table-cell>
              </tr>
            </iel-table>
          </div>
        </div>
        <p>Documentación</p>
        <div class="wrapper">
          <div>
            <a
              @click.prevent="
                openImage('Foto Fachada', customer.document.facade_photo)
              "
            >
              <img
                class="customer-image"
                :src="`${url}/${customer.document.facade_photo}`"
                alt=""
              />
            </a>
            <p>Foto Fachada</p>
          </div>
          <div>
            <a
              @click.prevent="
                openImage('Foto Adentro', customer.document.facade_photo)
              "
            >
              <img
                class="customer-image"
                :src="`${url}/${customer.document.indoor_photo}`"
                alt=""
              />
            </a>
            <p>Foto Adentro</p>
          </div>
          <div>
            <a
              @click.prevent="
                openImage('Foto Barra', customer.document.bar_photo)
              "
            >
              <img
                class="customer-image"
                :src="`${url}/${customer.document.bar_photo}`"
                alt=""
              />
            </a>
            <p>Foto Barra</p>
          </div>
          <div>
            <a
              @click.prevent="
                openImage('Foto Exhibidor', customer.document.display_photo)
              "
            >
              <img
                class="customer-image"
                :src="`${url}/${customer.document.display_photo}`"
                alt=""
              />
            </a>
            <p>Foto Exhibidor</p>
          </div>
          <div>
            <a
              @click.prevent="
                openImage(
                  'Foto Exhibidor Izquierdo',
                  customer.document.left_display_photo
                )
              "
            >
              <img
                class="customer-image"
                :src="`${url}/${customer.document.left_display_photo}`"
                alt=""
              />
            </a>
            <p>Foto Exhibidor Izquierdo</p>
          </div>
          <div>
            <a
              @click.prevent="
                openImage(
                  'Foto Exhibidor Derecho',
                  customer.document.right_display_photo
                )
              "
            >
              <img
                class="customer-image"
                :src="`${url}/${customer.document.right_display_photo}`"
                alt=""
              />
            </a>
            <p>Foto Exhibidor Derecho</p>
          </div>
          <div>
            <v-btn
              elevation="0"
              @click="openPdf(customer.document.evid_tax_registration)"
            >
              <v-icon>mdi-file-pdf-box</v-icon>
            </v-btn>
            <p>Constancia de Situación Fiscal</p>
            <p>{{ customer.document.evid_tax_registration }}</p>
          </div>
          <div>
            <v-btn
              elevation="0"
              @click="openPdf(customer.document.official_id)"
            >
              <v-icon>mdi-file-pdf-box</v-icon>
            </v-btn>
            <p>
              Identificación oficial de persona Fisica o representante legal
            </p>
            <p>{{ customer.document.official_id }}</p>
          </div>
          <div>
            <v-btn
              elevation="0"
              @click="openPdf(customer.document.proof_recidency)"
            >
              <v-icon>mdi-file-pdf-box</v-icon>
            </v-btn>
            <p>Comprobante de domicilio dirección fiscal</p>
            <p>{{ customer.document.proof_recidency }}</p>
          </div>
          <div v-if="customer.fiscal.delivery_fiscal_addres != 'Si'">
            <v-btn
              elevation="0"
              @click="openPdf(customer.document.proof_recidency_distinct)"
            >
              <v-icon>mdi-file-pdf-box</v-icon>
            </v-btn>
            <p>Comprobante de domicilio para entregas</p>
            <p>{{ customer.document.proof_recidency_distinct }}</p>
          </div>
          <div v-if="customer.fiscal.delivery_fiscal_addres == 'No'">
            <v-btn
              elevation="0"
              @click="openPdf(customer.document.shcp_opening)"
            >
              <v-icon>mdi-file-pdf-box</v-icon>
            </v-btn>
            <p>Formato de Alta de Apertura ante SAT</p>
            <p>{{ customer.document.shcp_opening }}</p>
          </div>
          <div v-if="customer.person_type == 'moral'">
            <v-btn elevation="0" @click="openPdf(customer.document.charter)">
              <v-icon>mdi-file-pdf-box</v-icon>
            </v-btn>
            <p>Acta constitutiva</p>
            <p>{{ customer.document.charter }}</p>
          </div>
          <div v-if="customer.person_type == 'moral'">
            <v-btn
              elevation="0"
              @click="openPdf(customer.document.power_attorney)"
            >
              <v-icon>mdi-file-pdf-box</v-icon>
            </v-btn>
            <p>
              Poder notarial para ser el representante legal de la persona moral
              o Física
            </p>
            <p>{{ customer.document.power_attorney }}</p>
          </div>
          <div
            v-if="
              customer.fiscal.delivery_fiscal_addres == 'No' &&
              customer.document.bank_reference
            "
          >
            <v-btn
              elevation="0"
              @click="openPdf(customer.document.bank_reference)"
            >
              <v-icon>mdi-file-pdf-box</v-icon>
            </v-btn>
            <p>Referencias Bancarias</p>
            <p>{{ customer.document.bank_reference }}</p>
          </div>
          <div v-if="customer.fiscal.request_credit == 'Si'">
            <v-btn
              elevation="0"
              @click="openPdf(customer.document.promissory_note)"
            >
              <v-icon>mdi-file-pdf-box</v-icon>
            </v-btn>
            <p>Pagaré</p>
            <p>{{ customer.document.promissory_note }}</p>
          </div>
          <div v-if="customer.fiscal.request_credit == 'Si'">
            <v-btn
              elevation="0"
              @click="openPdf(customer.document.official_id_endors)"
            >
              <v-icon>mdi-file-pdf-box</v-icon>
            </v-btn>
            <p>Identificación oficial de Aval</p>
            <p>{{ customer.document.official_id_endors }}</p>
          </div>
          <div v-if="customer.fiscal.request_credit == 'Si'">
            <v-btn
              elevation="0"
              @click="openPdf(customer.document.proof_recidency_endors)"
            >
              <v-icon>mdi-file-pdf-box</v-icon>
            </v-btn>
            <p>Comprobante de domicilio de Aval</p>
            <p>{{ customer.document.proof_recidency_endors }}</p>
          </div>
          <div v-if="customer.fiscal.line_request_credit > 500000">
            <v-btn
              elevation="0"
              @click="openPdf(customer.document.balance_sheet)"
            >
              <v-icon>mdi-file-pdf-box</v-icon>
            </v-btn>
            <p>Balance General</p>
            <p>{{ customer.document.balance_sheet }}</p>
          </div>
          <div v-if="customer.fiscal.line_request_credit > 500000">
            <v-btn
              elevation="0"
              @click="openPdf(customer.document.income_statements)"
            >
              <v-icon>mdi-file-pdf-box</v-icon>
            </v-btn>
            <p>Estado de Resultados</p>
            <p>{{ customer.document.income_statements }}</p>
          </div>
        </div>
        <template v-if="customer.promissory_notes.length > 0">
          <p>Solicitudes de pagarés pendientes</p>
          <iel-table
            :headers="[{ text: 'Descripcion' }, { text: 'Documento' }]"
          >
            <tr>
              <th class="boder-x-none text-dark">Tipo de solicitud</th>
              <iel-table-cell>
                {{
                  customer.promissory_notes[0]?.request_type_des?.description
                }}</iel-table-cell
              >
            </tr>
            <tr>
              <th class="boder-x-none text-dark">Estado</th>
              <iel-table-cell>
                {{
                  customer.promissory_notes[0]?.request_status?.description
                }}</iel-table-cell
              >
            </tr>
            <tr>
              <th class="boder-x-none text-dark">Aval</th>
              <iel-table-cell>{{
                customer.promissory_notes[0]?.bank_guarantee_name ?? 'Sin aval'
              }}</iel-table-cell>
            </tr>
            <tr>
              <th class="boder-x-none text-dark">
                Fecha de firma de pagaré / Monto
              </th>
              <iel-table-cell
                >{{ customer.promissory_notes[0]?.promissory_note_date }} /
                {{
                  customer.promissory_notes[0]?.promissory_note_amount
                }}</iel-table-cell
              >
            </tr>

            <tr v-for="(docu, index) in docs" :key="index">
              <th class="boder-x-none text-dark">{{ docu.text }}</th>
              <iel-table-cell>
                <a
                  v-if="customer.promissory_notes[0][docu.value]"
                  target="_link"
                  :href="`${url}/${customer.promissory_notes[0][docu.value]}`"
                >
                  <v-icon>mdi-file</v-icon>
                </a>
                <span v-else> N/A </span>
              </iel-table-cell>
            </tr>
          </iel-table>
        </template>
        <v-row>
          <v-col cols="12" md="6" sm="12" offset-md="6">
            <v-card outlined elevation="0">
              <v-card-title>Validar solicitud</v-card-title>
              <v-card-text>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                  @submit.prevent="updateRequest"
                >
                  <v-select
                    v-model="form.status"
                    :items="[
                      { id: 5, label: 'Aceptar' },
                      { id: 6, label: 'Rechazar' },
                    ]"
                    :rules="[(v) => !!v || 'El estado es requerido']"
                    label="Actualizar estado de solicitud"
                    required
                    item-text="label"
                    item-value="id"
                  />

                  <v-text-field
                    v-if="form.status == 6"
                    v-model="form.observations"
                    label="Observaciones"
                    required
                  />

                  <v-btn type="submit" color="#af001f" dark> Guardar </v-btn>
                </v-form>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </template>

    <v-dialog v-model="image.dialog">
      <v-card>
        <v-card-title>
          <span class="text-h5">Imagen {{ image.name }}</span>
        </v-card-title>
        <v-card-text>
          <img v-if="image.src" :src="image.src" alt="" />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="green darken-1" text @click="closeDialog">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
  import IelTable from '@/components/tables/IElTable.vue';
  import IelTableCell from '@/components/tables/IELTableCell.vue';
  import { mapActions, mapGetters } from 'vuex';
  import { DOCUMENTS } from '../client_request/promissory_notes/constants/requerimentDocuments';
  export default {
    name: 'CreditDetail',

    components: { IelTable, IelTableCell },
    data: () => ({
      url: '',
      customerId: null,
      loading: true,
      attrs: {
        class: 'mb-6',
        boilerplate: true,
        elevation: 2,
      },
      valid: false,
      form: {
        status: null,
        observations: null,
      },
      image: {
        dialog: false,
        name: null,
        src: null,
      },
      customerheders: [
        { text: 'Tipo' },
        { text: 'Canal' },
        { text: 'No. Cliente' },
        { text: 'RFC' },
        { text: 'Nombre' },
      ],
      addressheders: [
        { text: 'Calle' },
        { text: 'No. Ext' },
        { text: 'No. Int' },
        { text: 'Colonia' },
        { text: 'Municipio/Delegacion' },
        { text: 'Código Postal' },
        { text: 'Estado' },
      ],
      iusaheaders: [
        { text: 'No. Asesor' },
        { text: 'Asesor' },
        { text: 'Email Asesor' },
        { text: 'No. Gerente' },
        { text: 'Gerente' },
        { text: 'Email Gerente' },
        { text: 'No. Subgerente' },
        { text: 'Subgerente' },
      ],
      fiscalheders: [
        { text: '¿Solicita Crédito?' },
        { text: 'Condición de pago' },
        { text: '¿Entrega en domicilio fiscal?' },
        { text: 'Representante Legal' },
        { text: 'Línea de crédito solicitada' },
        { text: 'Ingresos mensuales' },
        { text: 'Tamaño del negocio' },
        { text: 'Giro del negocio' },
        { text: 'Las instalaciones son propias?' },
      ],
      fiscalpayment: [
        { text: 'Regimen fiscal' },
        { text: 'Forma Pago' },
        { text: 'Método de pago' },
        { text: 'CFDI' },
        { text: 'IVA' },
      ],
    }),
    computed: {
      ...mapGetters({
        customer: 'customersrequest/customer',
      }),
      docs() {
        return DOCUMENTS;
      },
    },
    mounted() {
      this.url = this.$filesUrl;
      this.customerId = this.$route.params.customerId;
      this.loadCustomerDetail(this.$route.params.customerId).finally(() => {
        this.loading = false;
      });
    },
    methods: {
      ...mapActions({
        loadCustomerDetail: 'customersrequest/loadCustomerDetail',
        updateCustomerRequest: 'customersrequest/updateCustomerRequest',
      }),
      openPdf(path) {
        window.open(`${this.url}/${path}`);
      },
      updateRequest() {
        this.updateCustomerRequest({
          id: this.customerId,
          form: this.form,
        }).then(() => {
          this.$toast.success('Solicitud actualizada correctamente');
          this.$router.replace('/credit/customers-request');
        });
      },
      openImage(name, path) {
        this.image.name = name;
        this.image.src = `${this.url}/${path}`;
        this.image.dialog = true;
      },
      closeDialog() {
        this.image.dialog = false;
        this.image.src = null;
        this.image.name = null;
      },
    },
  };
</script>

<style>
  .wrapper {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 10px;
    grid-auto-rows: minmax(100px, auto);
  }
  .customer-image {
    width: 100px;
  }
  .fiscal-data-sales {
    width: 100%;
  }
  .fiscal-data-data {
    width: 100%;
  }

  @media (min-width: 768px) {
    .fiscal-data {
      display: flex;
      gap: 1em;
      justify-content: space-between;
    }
    .fiscal-data-sales {
      width: 35%;
    }
    .fiscal-data-data {
      width: 65%;
    }
  }
</style>
